<script setup lang="ts">
interface Props {
  mobile: boolean
}
const props = defineProps<Props>()
const store = useStore()
const { currency, searchBarIsFocused } = storeToRefs(store)
const { path } = useRoute()
const search = ref(false)
const searchValue = ref()
const searchVData = ref()
const setFocus = (value: boolean) => {
  searchBarIsFocused.value = props.mobile ? value : false
}
const getSearch = () => {
  search.value = true
  nextTick(() => {
    document.getElementById('search')?.focus()
  })
  document.body.addEventListener('click', () => {
    search.value = false
  }, { once: true })
}
const change = async (value) => {
  setFocus(true)
  searchValue.value = value
  if (value.length > 1) {
    setTimeout(async () => {
      if (searchValue.value === value) {
        const data = await $fetch('/store-api/search', {
          method: 'POST',
          body: {
            'no-aggregations': true,
            limit: 4,
            search: value,
            order: 'score',
            associations: {
              media: {},
              seoUrls: {}
            },
            includes: {
              product: ['id', 'name', 'calculatedPrice', 'cover', 'customFields.product_city', 'urlPrefix', 'seoUrls'],
              calculated_cheapest_price: ['unitPrice'],
              product_media: ['media'],
              media: ['url', 'metaData', 'alt'],
              seo_url: ['seoPathInfo']
            }
          },
          query: {
            url: path
          }
        })
        searchVData.value = data.elements.length ? data : null
      }
    }, 500)
  } else {
    searchVData.value = null
  }
}
const redirect = async (item: any, more?: string) => {
  const url = more ? `/szukaj?q=${more}` : `/${item.extensions.urlPrefix.prefix}/${item.seoUrls?.[0].seoPathInfo}`
  if (props.mobile) {
    store.getModal(false, null)
  }
  search.value = false
  searchValue.value = null
  searchVData.value = null
  await navigateTo(url)
}
</script>

<template>
  <div
      v-if="mobile || search"
      :class="{
        'absolute lg:right-[110%] w-full lg:w-[550px] xl:w-[700px]': !mobile,
        'absolute z-20 w-full': searchVData && mobile
      }"
      @click.stop
    >
    <form @submit.prevent="redirect(null, searchValue)">
      <FormKit
        :id="!mobile ? 'search' : ''"
        type="search"
        label="Szukaj jazdy"
        placeholder="Szukaj jazdy"
        :value="searchValue"
        @input="change($event)"
        @touchend="setFocus(true)"
        @blur="setFocus(false)"
        autofocus
      />
    </form>
    <div v-if="searchVData && (!mobile || searchBarIsFocused)" class="bg-white border border-gray-400 rounded">
      <div v-for="item in searchVData.elements" :key="item.id" class="flex gap-[15px] border-b border-gray-400 p-[10px] cursor-pointer" @click="redirect(item)">
        <div class="w-[100px]">
          <Img
            v-if="item.cover"
            :src="item.cover.media.url"
            :width="item.cover.media.metaData.width.toString()"
            :height="item.cover.media.metaData.height.toString()"
            :alt="item.cover.media.alt"
          />
        </div>
        <div class="flex-1 flex flex-col gap-[10px]">
          <div>{{ item.name }}</div>
          <div>{{ item.customFields.product_city }}</div>
          <div>{{ item.calculatedPrice.unitPrice }} {{ currency }}</div>
        </div>
      </div>
      <div v-if="searchVData.total > searchVData.limit" class="p-[10px]">
        <div class="block btn btn-secondary" @click="redirect(null, searchValue)">
          <span>Pokaż więcej wyników</span>
          <i class="icon-arrow-button text-10" />
        </div>
      </div>
    </div>
  </div>
  <div v-if="!mobile" class="flex flex-col items-center text-gray-400 cursor-pointer" @click.stop="getSearch()">
    <i class="icon-search text-[20px]" />
    <span class="text-12">Szukaj</span>
  </div>
</template>
